import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './CakeDetailPage.css';
import UserManagerDialog from '../components/UserManagerDialog'; 
import CakeOrderPage from './CakeOrderPage'; 

export default function CakeDetailPage() {
  const { cakeId, categoryId } = useParams();
  const navigate = useNavigate();
  const [cake, setCake] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentImg, setCurrentImg] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showOrderDialog, setShowOrderDialog] = useState(false);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [orderCake, setOrderCake] = useState(null);
  const currentUser = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!cakeId || !categoryId) return;
    fetch(`https://devbite.vercel.app/api/cakedoctorcake_details?category_id=${encodeURIComponent(categoryId)}&cake_id=${encodeURIComponent(cakeId)}`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch cake');
        return res.json();
      })
      .then((data) => {
        setCake(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [cakeId, categoryId]);

  if (loading) return <div className="cake-detail-loading">Loading...</div>;
  if (error) return <div className="cake-detail-error">{error}</div>;
  if (!cake) return <div className="cake-detail-empty">No cake found</div>;

  const { imageUrls = [], name, icingType, description, price } = cake;

  // Carousel handlers
  const prevImg = () => setCurrentImg((prev) => (prev - 1 + imageUrls.length) % imageUrls.length);
  const nextImg = () => setCurrentImg((prev) => (prev + 1) % imageUrls.length);

  // Format price with commas for UGX
  const formatUGX = (val) => val ? `UGX ${Number(val).toLocaleString()}` : '';

  const navigateToOrder = () => {
    navigate('/cakeorder', { state: { cake } });
  };
  const handleBuyNow = () => {
    if (!currentUser) {
      setShowUserDialog(true);
      return;
    }
    navigateToOrder();
  };

  const shareCake = async () => {
    const cakeUrl = `${window.location.origin}/cake/${categoryId}/${cakeId}`;
    const shareData = {
      title: name,
      text: `Check out this cake: ${name}`,
      url: cakeUrl,
    };
    if (imageUrls && imageUrls.length > 0) {
      shareData.files = undefined;
      // Web Share API v2 (with files) is not widely supported, so just use url and thumbnail in link preview
    }
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        // fallback if needed
      }
    } else {
      // fallback: copy link
      await navigator.clipboard.writeText(cakeUrl);
      alert('Cake link copied to clipboard!');
    }
  };

  // Professional back navigation
  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else if (categoryId) {
      // Fallback: go to ItemsPage for this category with name
      let catName = cake?.categoryName || '';
      if (!catName && cake && cake.categoryId) {
        // fallback: try to get from categories list if available
        // (optional: could fetch category name by id if needed)
      }
      navigate(`/category/${categoryId}/${encodeURIComponent(catName)}`);
    } else {
      // Fallback: go home
      navigate('/');
    }
  };

  return (
    <div className="cake-detail-outer-bg">
      <div className="cake-detail-inner-bg">
        <div className="cake-img-hero-full">
          <button className="cake-back-btn" onClick={handleBack}>
            <span className="cake-back-icon">&#8592;</span>
          </button>
          <button className="cake-share-btn" onClick={shareCake} title="Share cake">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#e85d9e" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.59 13.51l6.83 3.98"/><path d="M15.41 6.51l-6.82 3.98"/></svg>
          </button>
          {imageUrls.length > 0 && (
            <div className="cake-carousel-container">
              <img
                src={imageUrls[currentImg]}
                alt={name}
                className="cake-img-hero-expanded"
                onClick={() => setShowModal(true)}
                style={{ cursor: 'zoom-in' }}
              />
              {imageUrls.length > 1 && (
                <>
                  <button className="cake-carousel-arrow left" onClick={prevImg}>&#8249;</button>
                  <button className="cake-carousel-arrow right" onClick={nextImg}>&#8250;</button>
                </>
              )}
              <div className="cake-carousel-dots">
                {imageUrls.map((_, idx) => (
                  <span
                    key={idx}
                    className={`cake-carousel-dot${idx === currentImg ? ' active' : ''}`}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="cake-detail-card">
          <div className="cake-detail-card-content">
            <div className="cake-detail-title">{name}</div>
            <div className="cake-detail-row">
              <div className="cake-detail-price">{formatUGX(price)}</div>
              {icingType && (
                <span className="cake-detail-icing-pill">{icingType}</span>
              )}
            </div>
            <div className="cake-detail-desc-section">
              <div className="cake-detail-desc-label">Description</div>
              <div className="cake-detail-desc">{description}</div>
            </div>
          </div>
          <div className="cake-detail-actions">
            <button className="cake-detail-buy-btn" onClick={handleBuyNow}>Buy Now</button>
          </div>
        </div>
      </div>

      {/* Modal for big image view */}
      {showModal && (
        <div className="cake-img-modal-bg" onClick={() => setShowModal(false)}>
          <img
            src={imageUrls[currentImg]}
            alt={name}
            className="cake-img-modal-img"
            onClick={e => e.stopPropagation()}
          />
          <button className="cake-img-modal-close" onClick={() => setShowModal(false)}>&#10005;</button>
        </div>
      )}
      {showUserDialog && (
        <UserManagerDialog open={showUserDialog} onClose={() => setShowUserDialog(false)} onLogin={() => { setShowUserDialog(false); navigateToOrder(); }} />
      )}
      {showOrderDialog && (
        <CakeOrderPage cake={orderCake} currentUser={currentUser} onOrderCreated={() => setShowOrderDialog(false)} />
      )}
    </div>
  );
}
